import React from 'react';
import Backend from '../../../Layouts/Backend';
import { Form, FormGroup } from 'reactstrap';
import CkBoxTree from '../../../UI/CkBoxTree';
import { withTranslation } from 'react-i18next';
import { Formik } from 'formik';
import { validationSchema } from './validation';
import { Input, Button, Alert } from '../../../UI/Common';
import helper from '../../../../utils/helper';
import PasswordConfirmation from '../../../UI/PasswordConfirmation';

function getNodeIds(nodes) {
  let ids = [];

  nodes &&
    nodes.forEach(({ value, children }) => {
      ids = [...ids, value, ...getNodeIds(children)];
    });

  return ids;
}

const NewRolePage = (props) => {
  const { t, isSubmitting, initialValues = {}, permissions, role = {} } = props;
  const [expanded, setExpanded] = React.useState(getNodeIds(permissions));
  React.useEffect(() => {
    setExpanded(getNodeIds(permissions));
  }, [permissions]);
  const [openModal, setOpenModal] = React.useState(false);
  const isRequireConfirmation = helper.isRequireConfirmation();
  function onSubmit(values) {
    if (isRequireConfirmation) {
      setOpenModal(true);
    } else {
      props.onSubmit(values);
    }
  }
  function getTitle() {
    if (!props.isCreate) return `${t('Edit Role')}: ${role.name || ''}`;
  }
  return (
    <Backend title={getTitle()}>
      <div className="content-inner">
        <div className="row">
          <div className="col">
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={(values) => onSubmit(values)}
            >
              {({
                values,
                handleChange,
                errors,
                setFieldValue,
                touched,
                handleSubmit,
              }) => {
                return (
                  <Form>
                    <PasswordConfirmation
                      isOpen={openModal}
                      onCancel={() => setOpenModal(false)}
                      onConfirm={() => {
                        setOpenModal(false);
                        props.onSubmit(values);
                      }}
                    />
                    <Input
                      required
                      readOnly={role.isStatic}
                      label="Name"
                      id="name"
                      value={values.name}
                      onChange={handleChange('name')}
                      error={errors.name}
                      invalid={touched.name}
                    />
                    <Input
                      readOnly={role.isStatic}
                      label="Description"
                      id="description"
                      value={values.description}
                      onChange={handleChange('description')}
                      error={errors.description}
                      invalid={touched.description}
                    />
                    <FormGroup>
                      <CkBoxTree
                        nodes={permissions}
                        checked={values.checked}
                        expanded={expanded}
                        onCheck={(checked) => setFieldValue('checked', checked)}
                        onExpand={(expanded) => setExpanded(expanded)}
                        checkModel="all"
                      />
                    </FormGroup>
                    <Alert.Error text={props.errors} />
                    <Button
                      id="create-role"
                      loading={isSubmitting}
                      onClick={handleSubmit}
                    >
                      <i className="md-icon">done</i>
                      {t(props.isCreate ? 'Create' : 'Save')}
                    </Button>
                  </Form>
                );
              }}
            </Formik>
          </div>
          <div className="col" />
        </div>
      </div>
    </Backend>
  );
};

export default withTranslation('app')(NewRolePage);
